import api from "./axios";

export const fetchHandoverLetters = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.page) params.append("page", filters.page);
  if (filters.per_page) params.append("per_page", filters.per_page);
  if (filters.customer_id) params.append("customer_id", filters.customer_id);
  if (filters.from_date) params.append("from_date", filters.from_date);
  if (filters.to_date) params.append("to_date", filters.to_date);
  if (filters.search) params.append("search", filters.search);
  return api.get(`/handover-letters?${params.toString()}`);
};

export const fetchHandoverLetterById = (id) => {
  return api.get(`/handover-letters/${id}`);
};

export const createHandoverLetter = (data) => {
  return api.post("/handover-letters", data);
};

export const updateHandoverLetter = (id, data) => {
  return api.put(`/handover-letters/${id}`, data);
};

export const deleteHandoverLetter = (id) => {
  return api.delete(`/handover-letters/${id}`);
};

export const openHandoverLetterPdf = async (id) => {
  const blob = await api.get(`/handover-letters/${id}/pdf`, {
    responseType: "blob",
  });

  if (blob instanceof Blob && blob.type && !blob.type.includes("pdf")) {
    const text = await blob.text();
    let errorMsg = "Server returned an error instead of PDF";
    try {
      const json = JSON.parse(text);
      errorMsg = json.message || errorMsg;
    } catch {
      // not JSON
    }
    throw new Error(errorMsg);
  }

  const pdfBlob = new Blob([blob], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);
  window.open(url, "_blank");
};
